/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import MsDyn365 from '@msdyn365-commerce/core';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IMfrmSocialIconsViewProps } from './mfrm-social-icons';
import Toast from './components/toast';
import { SocialIconsStateInput } from '../../actions/social-icons-state.action';

export default (props: IMfrmSocialIconsViewProps) => {
    const {
        iconText,
        image,
        Link,
        SocialIcon
    } = props;

    const { text } = props.config;

    //Modify image width for Facebook
    const socialIconFacebook = ((text?.toLowerCase() === 'facebook') ? 'social-media-icon-facebook' : '');
    const classes = `mfrm-social__image ${socialIconFacebook}`;

    //Managing state for opening and closing Toast indicator
    const [showToast, setShowToast] = React.useState<boolean>(false);
    const [copyLinkClicked, setCopyLinkClicked] = React.useState<boolean>(false);
    const updateShowToast = (closeToast: boolean):void => {
        setShowToast(closeToast);
    };

    function copyLink() {
        const el = document.createElement("input");
        el.value = window.location.href;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        setShowToast(true);
        setTimeout(()=> setShowToast(false), 7.5*1000);
        props.context.actionContext.update(new SocialIconsStateInput(), {copyLinkClick: true});

        if(MsDyn365.isBrowser && 'utag' in window && !copyLinkClicked) {
            // @ts-ignore
            utag.link({
                event: "social-copy-link-button-click",
                event_category: "mfrm social icons module",
                event_action: "copy link to clipboard button click",
                event_noninteraction: "false"
            });
        }
        setCopyLinkClicked(true);
    }

    function socialClick() {
        if (MsDyn365.isBrowser) {
            if ('utag' in window) {
                if(props.data.copyLinkClickState.result?.copyLinkClick) {
                    // @ts-ignore
                    utag.link({
                        event: "outbound-social-link-click",
                        event_category: "mfrm social icons module",
                        event_action: "social click with copied link",
                        event_label: `to: ${Link.href}`,
                        event_noninteraction: "false"
                    });
                } else {
                    // @ts-ignore
                    utag.link({
                        event: "outbound-social-link-click",
                        event_category: "mfrm social icons module",
                        event_action: "social click",
                        event_label: `to: ${Link.href}`,
                        event_noninteraction: "false"
                    });
                }
            }
            window.open(Link.href,Link.target);
        }
    }

    React.useEffect(() => {
        props.context.actionContext.update(new SocialIconsStateInput(), {copyLinkClick: false});
    }, []);

    if(Link){
        return (
            <Module {...SocialIcon} data-cy={`social-share-${text}`} onClick={() => socialClick()}>
                <Node {...Link}>
                    <div className={classes}>
                        {image}
                    </div>
                    <div className="mfrm-social__text">
                    <p>{iconText}</p>
                    </div>
                </Node>
                <div className="mfrm-social__vl1"></div>
            </Module>
        );
    } else {
        return (
            <Module {...SocialIcon} data-cy={`social-share-${text}`}>
               <div tabIndex={0} className="mfrm-social__link" onClick={() => copyLink()}>
                <div className="mfrm-social__image">
                    {image}
                </div>
                <div className="mfrm-social__text">
                   <p>{iconText}</p>
                </div>
               </div>
               <div className="mfrm-social__vl2"></div>
               <Toast closeToast={showToast} updateShowToast={updateShowToast}/>
            </Module>
        );
    }
};
